// e.g.: "Facial Hair", "Left Hand", "Hair", ...
export interface IAvatarAssetCategory {
    id: string;
    title: string;
    sortIndex: number;
    isNotVariable: boolean; // По дефолту false, true для "base", т.к. для этой категории нет выбора, основа у всех одинаковая
}
